import {Box, Typography} from '@mui/material';
import Input from '@/shared/components/Inputs/Input';
import {ReactComponent as DollarIcon} from '@icons/dollar-circle.svg';
import {H5, CAPTION, SUBTITLE2, SUBTITLE1} from '@/utils/constants';
import {addBidModalStyle} from './AddBidModal.styles';
import {isValidPositiveAmount} from '@/utils/helpers';

const AddBidModal = ({
	amount,
	setAmount,
	totalBids,
	maxBid,
	bidIncrement,
}: {
	amount: string;
	setAmount: (amount: string) => void;
	totalBids: number;
	maxBid: number;
	bidIncrement: number;
}) => {
	const onHandleChange = (value: string) => {
		if (value === '') {
			setAmount('');

			return;
		}

		const isValid = isValidPositiveAmount(value);
		if (isValid) {
			setAmount(value);
		}
	};
	return (
		<Box>
			<Typography variant={H5} sx={addBidModalStyle.title}>
				Place A Bid
			</Typography>
			<Box sx={addBidModalStyle.bidWrapper}>
				<Typography sx={addBidModalStyle.bid} variant={CAPTION}>
					<Typography variant={SUBTITLE2} sx={addBidModalStyle.bidValue}>
						{totalBids}
					</Typography>
					Bids
				</Typography>
				<Typography sx={addBidModalStyle.bid} variant={CAPTION}>
					<Typography variant={SUBTITLE2} sx={addBidModalStyle.bidValue}>
						{`$${maxBid}`}
					</Typography>
					Current bid
				</Typography>
			</Box>
			<Box sx={addBidModalStyle.search}>
				<DollarIcon />
				<Input
					type="text"
					placeholder="0"
					value={amount}
					onChange={(value: string) => {
						onHandleChange(value);
					}}
					label="Set your maximum bid"
				/>
				<Typography sx={addBidModalStyle.bidIncrement}>
					Your bid will automatically increase over the current winning bid by
					<Typography variant={SUBTITLE1} sx={{fontWeight: 'bold', display: 'inline', ml: 1}}>
						${bidIncrement}
					</Typography>{' '}
					until it reaches your maximum bid.
				</Typography>
			</Box>
		</Box>
	);
};

export default AddBidModal;
